<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-inexorange hover:text-white"  :href="route('login')">Recuperar clave</inertia-link>
      <span class="text-white font-medium"></span> 
    </h1>
    <div class="bg-transparent rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.email" :error="form.errors.email" class="pr-6 pb-8 w-full lg:w-3/6" label="Email" required/>
          <text-input v-if="ema" v-model="form.code" :error="form.errors.code" class="pr-6 pb-8 w-full lg:w-3/6" label="Código" required/>

          <text-input v-if="codigo" v-model="form.password" :error="form.errors.password" class="pr-6 pb-8 w-full lg:w-3/6" type="password" autocomplete="new-password" label="Password" required/>
          <text-input v-if="codigo" v-model="form.passwordR" :error="form.errors.passwordR" class="pr-6 pb-8 w-full lg:w-3/6" type="password" autocomplete="new-password" label="Repite Password" required/>

          
        </div>
         <br>  
                <div v-if="mensagge" role="alert" class="mt-3 relative flex w-full p-3 text-sm text-white bg-black rounded-md">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-5 w-5 mr-2"><path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"></path></svg>
                {{mensagge}}
              </div>
              <br>  
        <div class="px-8 py-4 bg-transparent flex justify-end items-center" style="color: black;">
           <button v-if="!ema"  class="text-inexorange hover:underline" tabindex="-1" type="button" @click="sendcodigo">Obtener código</button>
           <button v-if="ema && codigo==false"  class="text-inexorange hover:underline" tabindex="-1" type="button" @click="validarcodigo">Validar código</button>

          <loading-button :loading="form.processing" v-if="codigo" style="color: white;" class="px-8 py-4 btn-indigoOrange" type="submit">ACTUALIZAR USUARIO</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/LayoutPublic'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import axios from "axios";

export default {
  metaInfo: { title: 'Recuperar Clave' },
  components: {
    FileInput,
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  remember: 'form',
  props: {
    organizations: Array,
  },
  data() {
    return {
      codigo: false,
      ema: false,
      mensagge: '',
      form: this.$inertia.form({
        email: null,
        code: null,
        password: null,
        passwordR: null,

      }),
    }
  },
  methods: {
    store() {
      if(this.form.password==this.form.passwordR){
      this.form.post(this.route('userRecovery.store'))
      }
      else{
        this.mensagge='Contraseñas no coinciden';
      }
    },
    sendcodigo(){
        this.mensagge='';
       var data = new FormData();
       data.append('email', this.form.email);
       data.append('_method', 'POST');
       axios.post('/codePassword',data).then(response => {
          this.mensagge=response.data;
          if(response.data=='Email enviado con éxito')
          {
            this.ema = true;
          }
      }); 
    },
    validarcodigo(){
        this.mensagge='';
       var data = new FormData();
       data.append('email', this.form.email);
       data.append('code', this.form.code);
       data.append('_method', 'POST');
       axios.post('/codePasswordV',data).then(response => {
          this.mensagge=response.data;
          if(response.data=='Código correcto')
          {
            this.codigo = true;
          }
      }); 
    },
  },
}
</script>
